import { render, staticRenderFns } from "./TabModeratorPlayerActivity.vue?vue&type=template&id=d271fb26&"
import script from "./TabModeratorPlayerActivity.vue?vue&type=script&lang=js&"
export * from "./TabModeratorPlayerActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports